// Contact Information
// Set REACT_APP_SHOW_REAL_CONTACT=true in .env to display real contact details
const SHOW_REAL_CONTACT = process.env.REACT_APP_SHOW_REAL_CONTACT === 'true';

export const CONTACT_INFO = {
  primaryPhone: SHOW_REAL_CONTACT ? '+44 7917 106215' : '+44 7911 123456',
  primaryEmail: SHOW_REAL_CONTACT ? 'hello@travelmhor.com' : 'info@example.com',
  hours: {
    weekday: { open: '8:00 AM', close: '6:00 PM' },
    weekend: { open: '9:00 AM', close: '5:00 PM' }
  }
};

// Animation Timings (in milliseconds)
export const ANIMATION_TIMINGS = {
  phaseOne: 2500,
  phaseTwo: 5000,
  phaseThree: 6500,
  phaseComplete: 8500,
  contentFadeDelay: 500,
  contentFadeDuration: 2500,
  backgroundFadeDuration: 1500
};

// UI Configuration
export const UI_CONFIG = {
  navHeight: 80,
  maxPassengers: 100,
  minPassengers: 1,
  messageMaxLength: 1000,
  nameMaxLength: 100,
  emailMaxLength: 254,
  phoneMaxLength: 20,
  minFutureDate: 1 // days
};

// Carousel Configuration
export const CAROUSEL_CONFIG = {
  autoRotateInterval: 5000, // milliseconds between slides
  pauseSlides: 3 // number of slides to pause auto-rotate when user interacts
};

// Form Configuration
export const FORM_CONFIG = {
  submitCooldown: 10 // seconds between form submissions
};

// Validation Patterns
export const VALIDATION_PATTERNS = {
  name: /^[a-zA-Z\s'-]{1,100}$/,
  email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  phone: /^[\d\s\-+().]{1,20}$/,
  message: /^.{0,1000}$/
};

// Colors
export const COLORS = {
  primary: '#C9A961',
  dark: '#000000',
  darkBg: '#0a0a0a',
  darkCard: '#1a1a1a',
  darkBorder: '#333',
  textLight: '#f5f5f5',
  textMuted: '#cccccc',
  success: '#28a745',
  error: '#dc3545',
  navBg: 'rgba(0, 0, 0, 0.9)'
};

// Tour Types
export const TOUR_TYPES = {
  city: 'City Highlights Tour',
  wine: 'Wine Country Adventure',
  historical: 'Historical Heritage Tour',
  custom: 'Custom Tour'
};

// Result Page Types
export const RESULT_TYPES = {
  success: 'success',
  error: 'error',
  notFound: 'notFound'
};
